import type { FunctionComponent, ReactNode, MouseEventHandler } from 'react'
import styled, { css } from 'styled-components'
import Icon from '../../Icon/Icon'
import Chevron from '../../../assets/icons/chevronDown.svg'

export enum Variant {
  Inline = 'ínline',
  Card = 'card',
  Basic = 'basic',
  Blue = 'blue',
}

const StyledLink = styled.a<{ $variant?: Variant; $inlist?: boolean }>`
  color: var(--blue);
  display: inline-flex;
  align-items: center;
  &:hover {
    color: var(--red);
    svg {
      fill: var(--red);
    }
  }
  ${({ $variant }) =>
    $variant === Variant.Inline &&
    css`
      display: inline-flex;
    `}
  ${({ $inlist }) =>
    $inlist &&
    css`
      font-weight: 700;
      color: var(--dark);
      text-decoration: none;
      svg {
        margin-right: 0.25rem;
      }
    `}
  ${({ $variant }) =>
    $variant === Variant.Card &&
    css`
      color: var(--dark);
      text-decoration: none;
      &:focus,
      &:hover {
        color: inherit;
        text-decoration: none;
      }
    `}
    ${({ $variant }) =>
      $variant === Variant.Basic &&
      css`
        color: var(--dark);
        text-decoration: none;
        span svg path {
          fill: var(--dark);
        }
        &:focus,
        &:hover {
          color: var(--dark);
          text-decoration: underline;
          text-underline-offset: 2px;
          span svg path {
            fill: var(--dark);
          }
        }
      `}
    ${({ $variant }) =>
      $variant === Variant.Blue &&
      css`
        display: inline-flex;
        &:hover {
          color: var(--blue);
          text-decoration: none;
          svg {
            fill: var(--blue);
          }
        }
      `}
}
`

const Link: FunctionComponent<{
  children: ReactNode
  href?: string
  inList?: boolean
  onClick?: MouseEventHandler
  variant?: Variant
  style?: object
  target?: string
  rel?: string
  title?: string
}> = ({ children, href, inList, onClick, style, target, rel, title, variant, ...otherProps }) => (
  <StyledLink
    href={href}
    $inlist={inList}
    onClick={onClick}
    style={style}
    target={target}
    rel={rel}
    title={title}
    $variant={variant}
    {...otherProps}
  >
    {inList && (
      <Icon size={12} rotate={270}>
        <Chevron />
      </Icon>
    )}
    {children}
  </StyledLink>
)

export default Link
